/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyUploadedDataPackageSlug } from './CompanyUploadedDataPackageSlug';
import {
    CompanyUploadedDataPackageSlugFromJSON,
    CompanyUploadedDataPackageSlugFromJSONTyped,
    CompanyUploadedDataPackageSlugToJSON,
    CompanyUploadedDataPackageSlugToJSONTyped,
} from './CompanyUploadedDataPackageSlug';

/**
 * Serializer for creating new data uploads and listing them.
 * @export
 * @interface CompanyUploadedDataPackageRequest
 */
export interface CompanyUploadedDataPackageRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyUploadedDataPackageRequest
     */
    description: string;
    /**
     * 
     * @type {CompanyUploadedDataPackageSlug}
     * @memberof CompanyUploadedDataPackageRequest
     */
    slug?: CompanyUploadedDataPackageSlug;
    /**
     * 
     * @type {string}
     * @memberof CompanyUploadedDataPackageRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the CompanyUploadedDataPackageRequest interface.
 */
export function instanceOfCompanyUploadedDataPackageRequest(value: object): value is CompanyUploadedDataPackageRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CompanyUploadedDataPackageRequestFromJSON(json: any): CompanyUploadedDataPackageRequest {
    return CompanyUploadedDataPackageRequestFromJSONTyped(json, false);
}

export function CompanyUploadedDataPackageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUploadedDataPackageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'slug': json['slug'] == null ? undefined : CompanyUploadedDataPackageSlugFromJSON(json['slug']),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CompanyUploadedDataPackageRequestToJSON(json: any): CompanyUploadedDataPackageRequest {
    return CompanyUploadedDataPackageRequestToJSONTyped(json, false);
}

export function CompanyUploadedDataPackageRequestToJSONTyped(value?: CompanyUploadedDataPackageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'slug': CompanyUploadedDataPackageSlugToJSON(value['slug']),
        'notes': value['notes'],
    };
}

